<div class="site-wrapper w-full {{ companyType$ | async }}-theme {{headerStyleService.getHeaderClass()}}">
  <site-header></site-header>
  <main class="{{mainClass$ | async}}">
    <router-outlet></router-outlet>
    <loader-modal *ngIf="(isScopeLoading$ | async) && !isMyScopes"></loader-modal>
  </main>
</div>
<scope-ui-snackbar></scope-ui-snackbar>
